const title = "Custom Soccer Banners - High-Quality Team Banners | Team Banner Sports";
export {title}